import { IonButton, IonIcon, IonInput } from "@ionic/react";
import { chevronBack, chevronForward } from "ionicons/icons";
import { shiftDateRange } from "../utils/date.js";

export default function DateRangeNavigator({ value, onChange }) {
  function update(nextValue) {
    onChange(nextValue);
  }

  return (
    <div className="date-range-nav">
      <IonButton fill="clear" onClick={() => update(shiftDateRange(value, -1))} aria-label="Previous date range">
        <IonIcon icon={chevronBack} />
      </IonButton>

      <div className="date-range-fields">
        <IonInput
          className="metora-input compact-input"
          label="Start"
          labelPlacement="stacked"
          type="date"
          value={value.startDate}
          onIonInput={(event) =>
            update({
              ...value,
              startDate: event.detail.value ?? value.startDate,
            })
          }
        />
        <IonInput
          className="metora-input compact-input"
          label="End"
          labelPlacement="stacked"
          type="date"
          value={value.endDate}
          onIonInput={(event) =>
            update({
              ...value,
              endDate: event.detail.value ?? value.endDate,
            })
          }
        />
      </div>

      <IonButton fill="clear" onClick={() => update(shiftDateRange(value, 1))} aria-label="Next date range">
        <IonIcon icon={chevronForward} />
      </IonButton>
    </div>
  );
}
